const BaoKimOrderConfirmStatus = {
  PROCESSING: 'p',
  COMPLETED: 'c',
  DESTRUCTED: 'd'
}
export default BaoKimOrderConfirmStatus
